import Turnstile, { useTurnstile } from "react-turnstile";


function CloudFlareTurnstile(props) {

  return (
    <Turnstile
      sitekey="0x4AAAAAABs9d5YpigMQ7L10"
      theme="dark"
      onVerify={token => props.desiredFunction()}
    />
  );
}

export default CloudFlareTurnstile;